import React from "react";
import { t } from "i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";

import { OrganisationalViewProps } from "@models/components/organisation.model";
import modalSlice from "@slices/modal.slice";
import { RootState } from "@store/index";

const OrganisationalView: React.FC<OrganisationalViewProps> = ({
  clubId,
  occupation,
  totalResources,
}) => {
  const { isAuthenticated } = useSelector((State: RootState) => State.local);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleBookNow = () => {
    if (isAuthenticated) {
      navigate(`/organisation-info/${clubId}/booking`);
    } else {
      dispatch(modalSlice.actions.updateAuthModal(true));
    }
  };

  return (
    <div className="fg-card-facilities">
      <ul>
        <li>
          <span>
            {t("resources")} {totalResources}
          </span>
        </li>
        <li>
          <span>{occupation}</span>
        </li>
      </ul>
      <button
        onClick={handleBookNow}
        className="btn fg-btn fg-btn-lightblue fg-btn-booknow"
        data-testid="book-now-button"
      >
        {t("bookNow")}
      </button>
    </div>
  );
};
export default OrganisationalView;
